

export default function openFile(acceptFileType, onProcessOpenFile) {

    const handleChange = (e) => {
        if (onProcessOpenFile) {
            onProcessOpenFile(e?.target?.files[0] || undefined);
            if (e && e.target) {
                e.target.value = null;
            }
        }
    };

    let input = document.createElement('input');
    input.setAttribute('type', 'file');
    input.setAttribute('accept', acceptFileType);
    input.style.display = 'none';
    input.addEventListener('change', handleChange, false);
    document.body.appendChild(input);
    input.click();
    document.body.removeChild(input);
}
